import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {  RouterModule } from '@angular/router';
import { CommonService } from '@services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogSessionComponent } from '@components/shared/dialog-session/dialog-session.component';
import { Subscription } from 'rxjs';

/**
 * Root application component. Handles global session management and modal dialogs.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [RouterModule],
})
export class AppComponent implements OnInit, OnDestroy {
  /** Application title */
  title = 'SanofiCRT';
  /** Common utility service */
  private commonService = inject(CommonService);
  /** Modal dialog service */
  private modalService = inject(NgbModal);
  /** Subscription for session modal observable */
  private sessionModalSub?: Subscription;

  ngOnInit(): void {
    console.log('');
    // this.commonService.startCheckSession();
    // this.sessionModalSub = this.commonService.sessionModal.subscribe((res: boolean) => {
    //   if (res) {
    //     this.modalService.open(DialogSessionComponent, {
    //       centered: true,
    //       backdrop: 'static',
    //       keyboard: false,
    //     });
    //   }
    // });
  }

  ngOnDestroy(): void {
    if (this.sessionModalSub) {
      this.sessionModalSub.unsubscribe();
    }
  }
}
